export const getStatusBadgeClassOfRFQMilestone = status => {
  if (!status) return "badge-soft-secondary"

  const normalized = status.toLowerCase()

  switch (normalized) {
    case "pending":
      return "badge-soft-warning"
    case "send for review":
      return "badge-soft-info"
    case "approved":
      return "badge-soft-success"
    case "assigned":
      return "badge-soft-success"
    case "paid":
      return "badge-soft-primary"
    case "submitted":
      return "badge-soft-secondary"
    case "rejected":
    case "rework":
    case "not assigned":
    case "rejected rework":
      return "badge-soft-danger"
    default:
      return "badge-soft-dark"
  }
}
export const getStatusBadgeClassOfMainRFQ = statusId => {
  switch (statusId) {
    case 1:
      return "badge-soft-primary";       // e.g., Draft
    case 2:
      return "badge-soft-secondary";     // e.g., Submitted
    case 3:
      return "badge-soft-info";          // e.g., Under Review
    case 4:
      return "badge-soft-warning";       // e.g., Needs Revision
    case 5:
      return "badge-soft-success";       // e.g., Approved
    case 6:
      return "badge-soft-danger";        // e.g., Rejected
    case 7:
      return "badge-soft-dark";          // e.g., Archived
    case 8:
      return "badge-soft-info";         // e.g., Reopened
    case 9:
      return "badge-soft-success";       // e.g., In Progress
    case 10:
      return "badge-soft-info";          // e.g., In Review
    case 11:
      return "badge-soft-warning";       // e.g., On Hold
    case 12:
      return "badge-soft-danger";        // e.g., Escalated
    case 13:
      return "badge-soft-success";     // Closed
    case 14:
      return "badge-soft-primary";       // e.g., Finalized
    case 15:
      return "badge-soft-dark";          // e.g., Awaiting Payment
    case 16:
      return "badge-soft-secondary";       // e.g., Completed
    case 17:
      return "badge-soft-danger";        // e.g., Cancelled
    default:
      return "badge-soft-secondary";     // Fallback
  }
}

